import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

export const useLogClickConfirmVerification = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(() => {
    logAnalyticsEvent({
      name: 'CLICK_CONFIRM_VERIFICATION',
      channel: ['firebase', 'amplitude', 'ablylog'],
    });
  }, [logAnalyticsEvent]);
};
